// image
import heroImage1 from "../assets/hero_image_1.png";
import heroImage2 from "../assets/hero_image_2.png";
import heroImage3 from "../assets/hero_image_3.png";
import storeImage1 from "../assets/store_image_1.jpeg";
import storeImage2 from "../assets/store_image_2.jpg";
import storeImage3 from "../assets/store_image_3.jpeg";
import storeImage4 from "../assets/store_image_4.jpeg";

export const placeholderImg = (
  text,
  w = 600,
  h = 800,
  bg = "1a1a1a",
  fg = "c9a96e",
) =>
  `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}"><rect fill="#${bg}" width="${w}" height="${h}"/><text fill="#${fg}" font-family="Georgia,serif" font-size="20" x="50%" y="48%" text-anchor="middle">${text}</text><text fill="#666" font-family="sans-serif" font-size="12" x="50%" y="54%" text-anchor="middle">Legacy Timepieces</text></svg>`)}`;

export const heroPlaceholder = (text, w = 1400, h = 800) =>
  `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#0a0a0a"/><stop offset="50%" stop-color="#1a1a1a"/><stop offset="100%" stop-color="#2a2018"/></linearGradient></defs><rect fill="url(#g)" width="${w}" height="${h}"/><circle cx="${w * 0.7}" cy="${h * 0.4}" r="120" fill="none" stroke="#c9a96e" stroke-width="1" opacity="0.3"/><circle cx="${w * 0.7}" cy="${h * 0.4}" r="80" fill="none" stroke="#c9a96e" stroke-width="0.5" opacity="0.2"/><text fill="#c9a96e" font-family="Georgia,serif" font-size="14" x="${w * 0.7}" y="${h * 0.4 + 5}" text-anchor="middle" opacity="0.4">${text}</text></svg>`)}`;

export const catPlaceholder = (text, w = 600, h = 800) =>
  `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#1a1a1a"/><stop offset="100%" stop-color="#2a2018"/></linearGradient></defs><rect fill="url(#g)" width="${w}" height="${h}"/><text fill="#c9a96e" font-family="Georgia,serif" font-size="22" x="50%" y="50%" text-anchor="middle">${text}</text></svg>`)}`;

export const HERO_SLIDES = [
  {
    title: "Timeless Elegance",
    subtitle: "Curated luxury timepieces since 2015",
    cta: "Explore Collection",
    img: heroImage1,
  },
  {
    title: "Verified Authentic",
    subtitle: "Get your dream watch with fast availability",
    cta: "Contact Us",
    img: heroImage2,
  },
  {
    title: "Sell Your Watch",
    subtitle: "We offer the best price for your luxury timepieces",
    cta: "Get a Quote",
    img: heroImage3,
  },
];

export const STORE_IMAGES = [
  {
    src: storeImage1,
    alt: "Legacy Timepieces Boutique Storefront",
  },
  {
    src: storeImage2,
    alt: "Luxury watches display case",
  },
  {
    src: storeImage3,
    alt: "Watch collection interior",
  },
  {
    src: storeImage4,
    alt: "Elegant boutique consultation area",
  },
];
